import CountriesAddRegionModalView from "./countries_add_region_modal.html";

angular.module("countries")

    .controller("CountriesEditCtrl", ['$rootScope', '$scope', '$http', '$stateParams', 'Restangular', '$state', 'modalService', '$filter', 'gridService', '$q', '$uibModal', 'logService', function ($rootScope, $scope, $http, $stateParams, Restangular, $state, modalService, $filter, gridService, $q, $uibModal, logService) {

        $scope.allowWrite = true;
        let filter = false;
        $scope.regionFilter = {};

        $rootScope.title = $filter('translate')('countries.title');
        if (angular.isUndefined($stateParams.id) || $stateParams.id == ""   ) {
            
            $rootScope.breadcrumb = [
            { title: $filter('translate')('countries.list'), url: "countries.list" },
            { title: $filter('translate')('countries.add') }
            ];
            $scope.country = {
                name: '',
                created_at: new Date()
            };
        }
        else {

            $rootScope.breadcrumb = [
            { title: $filter('translate')('countries.list'), url: "countries.list" },
            { title: $filter('translate')('countries.edit') }
            ];


            Restangular.one('Countries', $stateParams.id).get().then(function (results) {
                $scope.country = results;
                logService.debug($scope.country);
            }, function (response) {
                $scope.errorMessage = response.message;
            });
        }

        $scope.addFile = function (flowFile) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
                var uri = event.target.result;
                $scope.$apply(function () {
                    $scope.country.logo = uri;
                });
            };
            fileReader.readAsDataURL(flowFile.file);
        };

        logService.debug($stateParams.id);
        

        $scope.gridRegions = {
            pdfTitle: $filter('translate')('countries.regions'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    name: 'name', displayName: $filter('translate')('countries.name'), enableFiltering: true, enableHiding: false,
                },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.edit'), action: 'ui-sref="countries.regions_edit({id:row.entity.id, parent_id: grid.appScope.country.id})"; ng-if="grid.appScope.allowWrite"', context: $scope, cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteRegionDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                }
            ],
            getData: function (options) {

                if (filter) {
                    options.name = $scope.regionFilter.name;
                }

                options.country_id = $scope.country.id;

                return Restangular.all('CountriesRegions').getList(options).then(function (results) {
                    return results;
                });
          
            }
        };

        $scope.search = function () {
            if (angular.isDefined($scope.gridRegions.loadData)) {
                filter = true;
                $scope.gridRegions.loadData();
            }
        }

        $scope.addRegion = function () {

            let $modalInstance = $uibModal.open({
                animation: true,
                template: CountriesAddRegionModalView,
                size: "lg",
                controller: "AddRegionModalCtrl",
                scope: $scope,
                resolve: {
                    value: function () { }
                },
            });


        };






        $scope.saveCountry = function () {
            if (angular.isUndefined($stateParams.id) || $stateParams.id == "")
                Restangular.all('Countries').post($scope.country).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('countries.create_success'));
                        $scope.country = result;
                        //$state.go("countries.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            else {
                $scope.country.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('countries.edit_success'));
                        //$state.go("countries.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        };

        $scope.deleteCountry = function () {

            modalService.confirm({
                title: $filter('translate')('countries.delete'),
                message: $filter('translate')('countries.delete_message')+" " + $scope.country.name + "?",
                onAccept: function () {
                    Restangular.one('Countries', $stateParams.id).remove().then(function () {
                        toastr.success($filter('translate')('countries.delete_success'));
                        $state.go("countries.list");
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };


        $scope.deleteRegionDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('countries.region_delete'),
                message: $filter('translate')('countries.region_delete_message') + " " + name + "?",
                onAccept: function () {
                    Restangular.one('CountriesRegions', id).remove().then(function () {
                        toastr.success($filter('translate')('countries.region_remove_success'));
                        $scope.gridRegions.data =
                            $scope.gridRegions.data.filter(function (el) { return el.id != $scope.id; });
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                    });
                }
            });

        };

    }])

    .controller('AddRegionModalCtrl', ['$scope', '$uibModalInstance', '$uibModal', '$http', 'Restangular', '$filter', 'LoginService', 'modalService', 'logService',
        function ($scope, $uibModalInstance, $uibModal, $http, Restangular, $filter, LoginService, modalService, logService) {

        // $scope.region = options.params;
        $scope.region = {};

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onAccept = function () {
            $scope.region.country_id = $scope.country.id;
            Restangular.all('CountriesRegions').post($scope.region).then(function (result) {
                if (typeof (result.id) != "undefined") {
                    toastr.success($filter('translate')('countries.region_created_success'));
                    $scope.gridRegions.loadData();
                    logService.debug($scope.region)

                } else {
                    $scope.errorMessage = result.message;
                }
            });

            $uibModalInstance.close();
        };
    }])

;